import { render, staticRenderFns } from "./indexNotYetPayment.vue?vue&type=template&id=087826bd"
import script from "./indexNotYetPayment.vue?vue&type=script&lang=js"
export * from "./indexNotYetPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports